import React from 'react';
import { getNodeDisplayName, getParameterDisplayName, getParameterType } from '../utils/nodeUtils';
import { updateWorkflowParameter } from '../utils/workflowUtils';

const ParameterEditor = ({ 
  workflow, 
  selectedNode, 
  selectedParameter, 
  parameterValue,
  onNodeSelect, 
  onParameterSelect, 
  onParameterChange, 
  onParameterSave 
}) => {
  if (!workflow) {
    return (
      <div className="parameter-editor">
        <p>No workflow loaded</p>
      </div>
    );
  }

  const nodes = Object.entries(workflow).sort(([, nodeA], [, nodeB]) => {
    const nameA = getNodeDisplayName(nodeA.class_type || '', nodeA);
    const nameB = getNodeDisplayName(nodeB.class_type || '', nodeB);
    return nameA.localeCompare(nameB);
  });

  return (
    <div className="parameter-editor">
      {/* Node Selection */}
      <div className="parameter-section">
        <select 
          value={selectedNode || ''} 
          onChange={(e) => onNodeSelect(e.target.value)}
        >
          <option value="">Setting...</option>
          {nodes.map(([nodeId, node]) => (
            <option key={nodeId} value={nodeId}>
              {getNodeDisplayName(nodeId, node)}
            </option>
          ))}
        </select>
      </div>

      {/* Parameter Selection */}
      {selectedNode && workflow[selectedNode] && (
        <div className="parameter-section">
          <select 
            value={selectedParameter || ''} 
            onChange={(e) => onParameterSelect(e.target.value)}
          >
            <option value="">Parameter...</option>
            {Object.entries(workflow[selectedNode].inputs || {}).map(([paramName, paramValue]) => (
              <option key={paramName} value={paramName}>
                {getParameterDisplayName(paramName)}: {String(paramValue)}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Parameter Editor */}
      {selectedNode && selectedParameter && (
        <div className="parameter-section">
          <div className="parameter-input-group">
            {getParameterType(selectedParameter) === 'number' ? (
              <input
                type="number"
                value={parameterValue}
                onChange={(e) => onParameterChange(e.target.value)}
                placeholder="Value"
              />
            ) : getParameterType(selectedParameter) === 'boolean' ? (
              <select 
                value={parameterValue} 
                onChange={(e) => onParameterChange(e.target.value)}
              >
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            ) : (
              <textarea
                value={parameterValue}
                onChange={(e) => onParameterChange(e.target.value)}
                placeholder="Value"
                rows={2}
              />
            )}
            <button 
              onClick={onParameterSave}
              className="parameter-save-btn"
            >
              Save
            </button>
          </div>
        </div>
      )}

      {/* Current Value Display */}
      {selectedNode && selectedParameter && (
        <div className="parameter-section">
          <div className="current-value">
            Current: {String(workflow[selectedNode].inputs[selectedParameter])}
          </div>
        </div>
      )}
    </div>
  );
};

export default ParameterEditor;
